import { Button, makeStyles } from "@material-ui/core";
import clsx from 'clsx';
import { useTranslation } from "react-i18next";
const useStyles = makeStyles((theme) => ({
  button: {
    fontSize: 14,
    fontWeight: 400,
    minWidth: 180,
    marginRight: 20,
    height: 50,
    marginTop: 10,
    backgroundColor: "white", border: "2px solid rgb(23, 135, 186)", color: "rgb(23, 135, 186)"

  },
  countButton: {
    fontSize: "12px !important",
    color: "rgb(23, 135, 186)",
    width: 25,
  },
  buttonSelected: {
    backgroundColor: "rgb(23, 135, 186)", border: "2px solid rgb(23, 135, 186)", color: "white !important"
  },
  white: {
    color: "white !important"
  }
}));

function ButtonVisaStatus(props) {
  const { t, i18n } = useTranslation();

  const classes = useStyles();
  const handleSearch = (event) => {
    props.onSearchDocuments(event);
  }
  return (
    <Button
      variant="contained"
      disabled={props.disabled}
      onClick={() => {
        handleSearch(props.smartserviceId)
      }}
      // style={{ backgroundColor: props.color }}
      // className={classes.button}
      className={clsx(classes.button, {
        [classes.buttonSelected]: props.active
      })}
      endIcon={<span className={clsx(classes.countButton, {
        [classes.white]: props.active
      })}>{props.count}</span>}
    >
      {props.title}
    </Button>
  );
}

export default ButtonVisaStatus;
